import { FIREBASE_CONFIG } from "@/constants/Configs";
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseApp = initializeApp(FIREBASE_CONFIG);

export const firebaseDatabase = getDatabase(firebaseApp);

export default firebaseApp;
